import { type Address } from "viem";
import { ADDRESSES } from "./contracts";

export interface TokenInfo {
  address: Address;
  symbol: string;
  name: string;
  decimals: number;
  logoUrl: string;
  isNative?: boolean;
  color?: string;
}

const TW_ETH = (addr: string) =>
  `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/${addr}/logo.png`;
const TW_BSC = (addr: string) =>
  `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets/${addr}/logo.png`;
const CG = (id: string) =>
  `https://assets.coingecko.com/coins/images/${id}/small/${id}.png`;

export const NATIVE_JASMY: TokenInfo = {
  address: "0x0000000000000000000000000000000000000000" as Address,
  symbol: "JASMY",
  name: "JASMY",
  decimals: 18,
  logoUrl: "/jasmy.svg",
  isNative: true,
};

export const WJASMY_TOKEN: TokenInfo = {
  address: ADDRESSES.WJASMY,
  symbol: "WJASMY",
  name: "Wrapped JASMY",
  decimals: 18,
  logoUrl: "/jasmy.svg",
};

// ─── Bridged from BSC ─────────────────────────────────────────────────────────

export const BJCT_TOKEN: TokenInfo = {
  address: "0x7Ab92678dEC662bEf9405D4fEA26c2d59C38D2Ae" as Address,
  symbol: "bJCT",
  name: "JCT (BSC)",
  decimals: 18,
  logoUrl: TW_BSC("0xea37a8de1de2d9d10772eeb569e28bfa5cb17707"),
};

export const BBNB_TOKEN: TokenInfo = {
  address: "0x2A9a9Ce6eAe11C04a58452E6500712A6B687ca63" as Address,
  symbol: "bBNB",
  name: "BNB (BSC)",
  decimals: 18,
  logoUrl: TW_BSC("0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"),
};

export const BUSDT_TOKEN: TokenInfo = {
  address: "0x8b551CD015688DaaA48fd5CD8f6944222FCa9c6B" as Address,
  symbol: "bUSDT",
  name: "USDT (BSC)",
  decimals: 18,
  logoUrl: TW_BSC("0x55d398326f99059fF775485246999027B3197955"),
};

export const BUSDC_TOKEN: TokenInfo = {
  address: "0x3b1b37bDBe20df26522a81B4Fe839d41705648a5" as Address,
  symbol: "bUSDC",
  name: "USDC (BSC)",
  decimals: 6,
  logoUrl: TW_BSC("0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d"),
};

export const BJASMY_BSC_TOKEN: TokenInfo = {
  address: "0x94b1f1495c360d57208d4059aa92fc77e3e4405a" as Address,
  symbol: "bJASMY",
  name: "JASMY (BSC)",
  decimals: 18,
  logoUrl: TW_BSC("0x15669CF161946C09a8B207650BfBB00e3d8A2E3E"),
};

// ─── Bridged from PulseChain ──────────────────────────────────────────────────

export const PHEX_TOKEN: TokenInfo = {
  address: "0x9F77c660602fAF3F4b345A7ADa1069a0B744E0FB" as Address,
  symbol: "pHEX",
  name: "HEX (PulseChain)",
  decimals: 8,
  logoUrl: TW_ETH("0x2b591e99afE9f32eAA6214f7B7629768c40Eeb39"),
};

export const PDAI_TOKEN: TokenInfo = {
  address: "0xB719759640e32F1aDD8F9F67c303DDD4f10DC3fa" as Address,
  symbol: "pDAI",
  name: "DAI (PulseChain)",
  decimals: 18,
  logoUrl: TW_ETH("0x6B175474E89094C44Da98b954EedeAC495271d0F"),
};

export const PWBTC_TOKEN: TokenInfo = {
  address: "0x7D68dc061bF89B00236950d288155767459e40Fb" as Address,
  symbol: "pWBTC",
  name: "WBTC (PulseChain)",
  decimals: 8,
  logoUrl: TW_ETH("0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"),
};

export const PGYEN_TOKEN: TokenInfo = {
  address: "0x6E218Ab12106473E013AD5f4836220825A55CA45" as Address,
  symbol: "pGYEN",
  name: "GYEN (PulseChain)",
  decimals: 6,
  logoUrl: TW_ETH("0xC08512927D12348F6620a698105e1BAac6EcD911"),
};

export const PJASMY_TOKEN: TokenInfo = {
  address: "0x6d5Ce519478088127389c3eBe6f312736d027484" as Address,
  symbol: "pJASMY",
  name: "JASMY (PulseChain)",
  decimals: 18,
  logoUrl: "/jasmy.svg",
};

export const DJNN_TOKEN: TokenInfo = {
  address: "0xEEAE625913aEE341eCCb5Fbe34D5e4FC3a1A3397" as Address,
  symbol: "DjnnX",
  name: "Jasmy Djnn",
  decimals: 18,
  logoUrl: "/djnn.svg",
};

// ─── PulseChain bridged tokens on JasmyChain ─────────────────────────────────
export const PDAI_JASMY_TOKEN: TokenInfo = {
  address: "0xB719759640e32F1aDD8F9F67c303DDD4f10DC3fa" as Address,
  symbol: "pDAI",
  name: "DAI (PulseChain)",
  decimals: 18,
  logoUrl: TW_ETH("0x6B175474E89094C44Da98b954EedeAC495271d0F"),
};

export const PCOCK_TOKEN: TokenInfo = {
  address: "0x09BCa00902C2B88cee07ffb70FFC2f7E9D777ace" as Address,
  symbol: "pCOCK",
  name: "COCK (PulseChain)",
  decimals: 18,
  logoUrl: "/jasmy-token.svg",
};

export const XUSDP_TOKEN: TokenInfo = {
  address: "0x56C94A5cd6B26988118D5ad4eF87f48ce44bD904" as Address,
  symbol: "xUSDP",
  name: "xUSDP",
  decimals: 18,
  logoUrl: "/jasmy-token.svg",
};

export const PLSX_JASMY_TOKEN: TokenInfo = {
  address: "0xc17EB7Fb50a01eE2aF05D765faf1e0F495f06a18" as Address,
  symbol: "PLSX",
  name: "PulseX (Bridged)",
  decimals: 18,
  logoUrl: "/jasmy-token.svg",
};

// ─── JasmyChain Native V2 Tokens (live pairs) ────────────────────────────────

export const JUSDT_TOKEN: TokenInfo = {
  address: "0x5F81Ad9D48062B1Ad084489b075b13E38DC76169" as Address,
  symbol: "USDT",
  name: "USDT (JasmyChain)",
  decimals: 18,
  logoUrl: TW_ETH("0xdAC17F958D2ee523a2206206994597C13D831ec7"),
};

export const FUD_TOKEN: TokenInfo = {
  address: "0xd056464200B2a072A13908c31C3831444cEa2086" as Address,
  symbol: "FUD",
  name: "FUD",
  decimals: 18,
  logoUrl: "/jasmy-token.svg",
};

export const PIKA_TOKEN: TokenInfo = {
  address: "0x11190e3609C94648C1a3E7B2035481584Bdea1D7" as Address,
  symbol: "Pikachu",
  name: "Pikachu",
  decimals: 18,
  logoUrl: "/jasmy-token.svg",
};

export const XCN_TOKEN: TokenInfo = {
  address: "0x9796dFA56AC16eAff1039b7AB8688EB6C2F9A275" as Address,
  symbol: "XCN",
  name: "XCN",
  decimals: 18,
  logoUrl: "/jasmy-token.svg",
};

export const RWB_TOKEN: TokenInfo = {
  address: "0xAc6ecE41E7Db676135aAdE3b60ECadF5184F71Ee" as Address,
  symbol: "RWB",
  name: "RWB",
  decimals: 18,
  logoUrl: "/jasmy-token.svg",
};

// ─── JasmyChain Ecosystem Meme Tokens (V3 pool pairs) ────────────────────────

export const BONK_TOKEN: TokenInfo = { address: "0x287cA02c914f789B128b69cAA17a8Db6C824cF4c" as Address, symbol: "BONK", name: "BONK", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const FLUFF_TOKEN: TokenInfo = { address: "0xbeDd3a163F56FeD14c677022F623A7c6D3cd7F5D" as Address, symbol: "FLUFF", name: "FLUFF", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const SAMURAI_TOKEN: TokenInfo = { address: "0x697Ed307089e9dACEcAd48d07b5784fcF26924cF" as Address, symbol: "SAMURAI", name: "SAMURAI", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const JBTC_TOKEN: TokenInfo = { address: "0x7Ff9f5Ee66079f1EBE12731ee2E813D4d29d478d" as Address, symbol: "JBTC", name: "JBTC", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const PAWS_TOKEN: TokenInfo = { address: "0x80f5e1BaFC07b4386D979acBF7B3551513a4521C" as Address, symbol: "PAWS", name: "PAWS", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const MEOW_TOKEN: TokenInfo = { address: "0x777B2aF4010F2390e10f462bfa4F609dB80B1D3e" as Address, symbol: "MEOW", name: "MEOW", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const JMEME_TOKEN: TokenInfo = { address: "0x568A7391eB4643365f3B680ADD465E2c9E5b1d1e" as Address, symbol: "JMEME", name: "JMEME", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const JCAT_TOKEN: TokenInfo = { address: "0x60BEff5609D72d94d3A60be6aF0C629d5713741d" as Address, symbol: "JCAT", name: "JCAT", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const PANDA_TOKEN: TokenInfo = { address: "0xF4009368cd610054A6519eaC857EDE14B47157a7" as Address, symbol: "PANDA", name: "PANDA", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const CHKN_TOKEN: TokenInfo = { address: "0xE1E02A83db3e13863496529cF7fC0855c76a5E76" as Address, symbol: "CHKN", name: "CHKN", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const DOGN_TOKEN: TokenInfo = { address: "0x72C9c72eDa0c5B35C799160D0CA6c1559b09FDDF" as Address, symbol: "DOGN", name: "DOGN", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const MONA_TOKEN: TokenInfo = { address: "0x1A54e797884B4456FDdb84b65B5CA8daBed12D45" as Address, symbol: "MONA", name: "MONA", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const PIRA_TOKEN: TokenInfo = { address: "0xc8DBd25927700BeC0875eA2E7Df1D4Db85DF2fA2" as Address, symbol: "PIRA", name: "PIRA", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const SUZUNEKO_TOKEN: TokenInfo = { address: "0x5746eD7df568f7F37C4Ec8dF180976B9dF9132Cb" as Address, symbol: "SUZUNEKO", name: "SUZUNEKO", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const JYTO_TOKEN: TokenInfo = { address: "0x3c429130057B44f4E9f8c07Bad5FD7684D985a99" as Address, symbol: "JYTO", name: "JYTO", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const RUSTY_TOKEN: TokenInfo = { address: "0x738D1B68670d3FBd3A11F28c9dfe221Fe484337e" as Address, symbol: "RUSTY", name: "RUSTY", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const SILVER_TOKEN: TokenInfo = { address: "0xbD99b41F6071FBBEaBf52fF07ce1adEB78687f66" as Address, symbol: "SILVER", name: "SILVER", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const KAMI_TOKEN: TokenInfo = { address: "0x3273F3975c3a5E1780DD4D00397bd4C8F5F390Fb" as Address, symbol: "KAMI", name: "KAMI", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const TAIKA_TOKEN: TokenInfo = { address: "0x311EEEa5fd2e823ef1C784a2Ea3a5b6259bAe4c5" as Address, symbol: "TAIKA", name: "TAIKA", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const META_TOKEN: TokenInfo = { address: "0x6Cee62Ef20c3fa17f01d9C69531f4A734d4ded13" as Address, symbol: "META", name: "META", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const KING_TOKEN: TokenInfo = { address: "0xbFE25E0C01026bA196561805785A451b4342D5e2" as Address, symbol: "KING", name: "KING", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const PENG_TOKEN: TokenInfo = { address: "0x5F29a628e9320F04Dca9308ED30239F3578d3231" as Address, symbol: "PENG", name: "PENG", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const NDRIFT_TOKEN: TokenInfo = { address: "0x189d8b8bE6E60688aacd46E96c4CF5CA9617742F" as Address, symbol: "NDRIFT", name: "NDRIFT", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const LUCK_TOKEN: TokenInfo = { address: "0xEF5b75c4bcA74c284BFf4DeF039a0353383341A1" as Address, symbol: "LUCK", name: "LUCK", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const ATTI_TOKEN: TokenInfo = { address: "0x4884F3b4a286a69e595F6A4102418CfD63C56CD3" as Address, symbol: "ATTI", name: "ATTI", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const JSBT_TOKEN: TokenInfo = { address: "0x0E161B52828d69BA93e3183CDD1AFfa1e2Ab1942" as Address, symbol: "JSBT", name: "JSBT", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const JMIL_TOKEN: TokenInfo = { address: "0x54Ea1D9853aB80469Aca10D492d1C20E2B0D896b" as Address, symbol: "JMIL", name: "JMIL", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const ASAN_TOKEN: TokenInfo = { address: "0xCfD34e366DD2AE9868fFf56B5514015c3dabB321" as Address, symbol: "ASAN", name: "ASAN", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const SIRO_TOKEN: TokenInfo = { address: "0xB9B41E734B1479959851058F944e8d8c0C46b0aF" as Address, symbol: "SIRO", name: "SIRO", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const JKEY_TOKEN: TokenInfo = { address: "0x7e6b443a73c53D878d16Cd5bAd001d593d11249c" as Address, symbol: "JKEY", name: "JKEY", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const DNDN_TOKEN: TokenInfo = { address: "0xc00BD64fece327bb307F2f7acF2acEBa27d65B15" as Address, symbol: "DNDN", name: "DNDN", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const INCO_TOKEN: TokenInfo = { address: "0xa2aeaBf1FD889D600891B0825349C4b15Cf38a3a" as Address, symbol: "INCO", name: "INCO", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const AGRI_TOKEN: TokenInfo = { address: "0x4Fa65828282176AD9233D634b47A59aD7eAC4A12" as Address, symbol: "AGRI", name: "AGRI", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const ETHR_TOKEN: TokenInfo = { address: "0x82b43bF8aec287db1eA61254D9e5B4852854e56F" as Address, symbol: "ETHR", name: "ETHR", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const MICH_TOKEN: TokenInfo = { address: "0xbFc22251A06253402bc35403B7F9dcB4895Ca834" as Address, symbol: "MICH", name: "MICH", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const THUMB_TOKEN: TokenInfo = { address: "0xC862a7d70d416bDEDc847eeFd0EE932707C05831" as Address, symbol: "THUMB", name: "THUMB", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const DECOY_TOKEN: TokenInfo = { address: "0xa712FE4ae736BaC13213fb10E9Aa4A741765e27A" as Address, symbol: "DECOY", name: "DECOY", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const WASA_TOKEN: TokenInfo = { address: "0xA86c08B4B5c8eB970c5096c1cc07133c45485cA2" as Address, symbol: "WASA", name: "WASA", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const MKTC_TOKEN: TokenInfo = { address: "0x6fe1b5F09bEe3A34e7601b2159E7dcf3BC1cc7f3" as Address, symbol: "MKTC", name: "MKTC", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const JURD_TOKEN: TokenInfo = { address: "0xaD8a3A25110a3dbeb1D2523DCd5bA61ab1422A7B" as Address, symbol: "JURD", name: "JURD", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const SUKR_TOKEN: TokenInfo = { address: "0xa508d4983ecdFdFA40859a14AF7Fe181fc7f5d64" as Address, symbol: "SUKR", name: "SUKR", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const TUNTUN_TOKEN: TokenInfo = { address: "0x709c3F17F36799fe673EC978793E93499Ad60cEB" as Address, symbol: "TUNTUN", name: "TUNTUN", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const SUBH_TOKEN: TokenInfo = { address: "0x1cc92196F8A3a64D204A58A139B1a8c136892B1E" as Address, symbol: "SUBH", name: "SUBH", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const SUBK_TOKEN: TokenInfo = { address: "0x0e5d433012d6CA0c8712E80C6D6D83328d8E6b27" as Address, symbol: "SUBK", name: "SUBK", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const SAMA_TOKEN: TokenInfo = { address: "0x300D0354d4589e0E1e4AeA57B29F6e9bD2B5861A" as Address, symbol: "SAMA", name: "SAMA", decimals: 18, logoUrl: "/jasmy-token.svg" };
export const KNTK_TOKEN: TokenInfo = { address: "0x0D157944147DE58f5DA34C4BDa444397B5787Cdf" as Address, symbol: "KNTK", name: "KNTK", decimals: 18, logoUrl: "/jasmy-token.svg" };

export const DEFAULT_TOKEN_LIST: TokenInfo[] = [
  NATIVE_JASMY,
  WJASMY_TOKEN,
  DJNN_TOKEN,
  // PulseChain bridged (priority for DJNN DEX)
  PDAI_JASMY_TOKEN,
  PCOCK_TOKEN,
  XUSDP_TOKEN,
  PLSX_JASMY_TOKEN,
  // JasmyChain V2 native tokens (live pairs)
  JUSDT_TOKEN,
  FUD_TOKEN,
  PIKA_TOKEN,
  XCN_TOKEN,
  RWB_TOKEN,
  // Bridged tokens
  BJASMY_BSC_TOKEN,
  PJASMY_TOKEN,
  BJCT_TOKEN,
  BBNB_TOKEN,
  BUSDT_TOKEN,
  BUSDC_TOKEN,
  PHEX_TOKEN,
  PDAI_TOKEN,
  PWBTC_TOKEN,
  PGYEN_TOKEN,
  // JasmyChain ecosystem meme tokens
  BONK_TOKEN,
  FLUFF_TOKEN,
  SAMURAI_TOKEN,
  JBTC_TOKEN,
  PAWS_TOKEN,
  MEOW_TOKEN,
  JMEME_TOKEN,
  JCAT_TOKEN,
  PANDA_TOKEN,
  CHKN_TOKEN,
  DOGN_TOKEN,
  MONA_TOKEN,
  PIRA_TOKEN,
  SUZUNEKO_TOKEN,
  JYTO_TOKEN,
  RUSTY_TOKEN,
  SILVER_TOKEN,
  KAMI_TOKEN,
  TAIKA_TOKEN,
  META_TOKEN,
  KING_TOKEN,
  PENG_TOKEN,
  NDRIFT_TOKEN,
  LUCK_TOKEN,
  ATTI_TOKEN,
  JSBT_TOKEN,
  JMIL_TOKEN,
  ASAN_TOKEN,
  SIRO_TOKEN,
  JKEY_TOKEN,
  DNDN_TOKEN,
  INCO_TOKEN,
  AGRI_TOKEN,
  ETHR_TOKEN,
  MICH_TOKEN,
  THUMB_TOKEN,
  DECOY_TOKEN,
  WASA_TOKEN,
  MKTC_TOKEN,
  JURD_TOKEN,
  SUKR_TOKEN,
  TUNTUN_TOKEN,
  SUBH_TOKEN,
  SUBK_TOKEN,
  SAMA_TOKEN,
  KNTK_TOKEN,
];

export enum TokenStatus {
  Live = 0,
  Graduated = 1,
  Rugged = 2,
  Delisted = 3,
}

export interface MemeToken {
  id: bigint;
  tokenAddress: Address;
  name: string;
  symbol: string;
  description: string;
  imageUri: string;
  creator: Address;
  reserveBalance: bigint;
  tokensSold: bigint;
  tradingVolume: bigint;
  createdAt: bigint;
  graduatedAt: bigint;
  status: TokenStatus;
  holderCount: bigint;
  tradeCount: bigint;
}

export interface TokenStats {
  price: bigint;
  marketCap: bigint;
  reserveBalance: bigint;
  tokensSold: bigint;
  progress: bigint;
  status: TokenStatus;
}

export function tokenStatusLabel(status: TokenStatus): string {
  switch (status) {
    case TokenStatus.Live:
      return "Live";
    case TokenStatus.Graduated:
      return "Graduated";
    case TokenStatus.Rugged:
      return "Rugged";
    case TokenStatus.Delisted:
      return "Delisted";
  }
}

export function tokenStatusColor(status: TokenStatus): string {
  switch (status) {
    case TokenStatus.Live:
      return "text-primary";
    case TokenStatus.Graduated:
      return "text-secondary";
    case TokenStatus.Rugged:
      return "text-error";
    case TokenStatus.Delisted:
      return "text-text-tertiary";
  }
}
